export default {
  "menu.welcome": "欢迎",
  "menu.ec": "电商会计",
  "menu.ec.recon": "电商对账",
  "menu.ma": "管理会计",
  "menu.ma.salesForecast": "销售预测",
};
